import { render, staticRenderFns } from "./ProxyListTable.vue?vue&type=template&id=5ed035f0&scoped=true&"
import script from "./ProxyListTable.vue?vue&type=script&lang=ts&"
export * from "./ProxyListTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProxyListTable.vue?vue&type=style&index=0&id=5ed035f0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed035f0",
  null
  
)

export default component.exports